import { MemoryRepository } from "./memoryRepository"
import { GetNewController } from "./factoryController"
import { Save } from "./undoRedo"
import { SingletonEnginnering } from "./singletonEngineering";
import { Types } from "../../utils/nodeTypes";
import BuildSVG from "../../utils/buildSVG";

export var SingletonFlowchart = {
    instance: function() {
        if (!SingletonFlowchart.instance) {
            SingletonFlowchart.instance = this;
        }
        return SingletonFlowchart.instance;
    },

    svg: null,
    nodeClicked: false,
    selected: null,
    selectedId: null,
    clicked: null,
    copied: new Array(),
    loadDatabaseNodes: () => {},
    readOnly: false,
    selectedNodes: new Array(),
    transform: null,
    openDialog: () => {},

    Memory: new MemoryRepository(),
    wasModified: false,

    SaveStatus: function() {
        this.wasModified = true;
        Save()
    },

    selectNode: function(idHtml) {
        this.clicked = true
        this.selected = idHtml;
        this.selectedId = getId(idHtml)
    },

    unSelectNode: function() {
        this.clicked = false;
        this.selected = '';
        this.selectedId = '';
        this.selectedNodes = new Array();
        this.copied = new Array();
    },

    removeNodeSelected: function() {
        this.SaveStatus();
        if (!this.selectedNodes || this.selectedNodes.length == 0) {
            this.Memory.removeNode(this.selectedId)
            this.unSelectNode();
        } else {
            this.selectedNodes.forEach(n => {
                this.Memory.removeNode(n.id);
            })
            this.unSelectNode();
        }
    },

    setReadOnly: function(value = true) {
        this.Memory.memory.forEach(n => {
            n.setStatus(value)
        })
    },

    loadArea: async function(areaNodes, openDialog, loadFlowchartTo){
        await areaNodes.configuration.forEach(async (node) => {
            try {
              node.readOnly = this.readOnly;
              let ctr = this.getController(node)
              if(!ctr) return
              await ctr.loadNode(node, openDialog, loadFlowchartTo);
            } catch (e) {
              console.log("Falha ao carregar o nó: ", node);
              console.log("Erro: ", e);
            }
        });

        await this.Memory.reloadNodes();

        if(areaNodes.transform){
            this.transform = areaNodes.transform
            BuildSVG.Resize(areaNodes.transform)
        }

        setTimeout(this.SaveStatus, 200);
        this.wasModified = false;
    },

    getController(node){
        return GetNewController(node.type, node.name);
    },

    SaveNode(node){
        let nodeToEdit = this.Memory.memory.find(n => n.isEquals(node))
        if(nodeToEdit)
            nodeToEdit.copyFrom(node)
    },

    changeView(prop){
        for(let i in this.Memory.memory){
            let node = this.Memory.memory[i]
            if(node.type == new Types().Current && (String(node.dataType).toUpperCase().includes("CORRENTES") || String(node.dataType).toUpperCase().includes("CORRENTEINTERNA")) ){
                if(node.data[0]){
                    let refProps = SingletonEnginnering.getReferenceProperties(node.data[0].index);
                    let propFounded = refProps.find(p => p.key == prop)
                    node.setReference(propFounded)
                }
            }
        }
    },

    Kill() {
        this.svg = null;
        this.nodeClicked = false;
        this.selected = null;
        this.selectedId = null;
        this.clicked = null;
        this.copied = new Array();
        this.readOnly = false;
        this.selectedNodes = new Array();
        this.Memory = new MemoryRepository();
        this.wasModified = false;
        this.instance = null
    },
}

function getId(idHtml) {
    let token = idHtml.split('-');
    return token.length == 2 ? token[1] : "";
}